/*
 * Buy box — Beam LP family. Wires the quantity options, flavor chips and plan
 * toggle, and keeps the sticky bar (if present, in a separate section) in sync.
 * Add-to-cart itself is handled by the theme <product-form> element.
 * Document-wide + guarded so it runs once no matter how many sections load it.
 *
 * Prices are never computed here. Liquid renders every quantity's prices
 * pre-formatted onto the quantity buttons, so switching quantity is a swap of
 * already-correct strings rather than a reimplementation of the shop's money
 * format. A buy box with no quantity options (the Glow LP) simply keeps the
 * prices Liquid put on the container.
 */
(function () {
  if (window.__glpBuyboxLp) return;
  window.__glpBuyboxLp = true;

  function init() {
    var buybox = document.querySelector(".glp-buybox");
    if (!buybox) return;
    // The theme editor re-renders sections after load, which replaces this DOM
    // and silently drops every listener — chips and plans go dead in the
    // customizer while the storefront looks fine. Re-run on the editor's
    // section events; the element guard keeps a live page from double-binding.
    if (buybox.dataset.glpWired === "1") return;
    buybox.dataset.glpWired = "1";

    var variantInput = buybox.querySelector('input[name="id"]');
    var planInput = buybox.querySelector('input[name="selling_plan"]');
    var qtyInput = buybox.querySelector('input[name="quantity"]');
    var atcLabel = buybox.querySelector(".glp-atc__label");
    var flavorName = buybox.querySelector(".glp-flavor-name");
    var planMeta = buybox.querySelector(".glp-plan--sub .glp-plan__meta");
    var subPriceEl = buybox.querySelector(".glp-plan--sub .glp-plan__price");
    var subCompareEl = buybox.querySelector(".glp-plan--sub .glp-plan__compare");
    var oncePriceEl = buybox.querySelector(".glp-plan__price--once");
    var onceCompareEl = buybox.querySelector(".glp-plan__compare--once");
    var stickyFlavor = document.querySelector(".glp-sticky__flavor");
    var stickyPrice = document.querySelector(".glp-sticky__price");
    var stickyStrike = document.querySelector(".glp-sticky__strike");
    var stickyPer = document.querySelector(".glp-sticky__per");

    // Current price set — starts at whatever Liquid rendered, then follows the
    // selected quantity option.
    var subPrice = buybox.dataset.subPrice || "";
    var oncePrice = buybox.dataset.oncePrice || "";
    var compare = buybox.dataset.compare || "";
    var ctaSub = buybox.dataset.ctaSub || "START MY GLOW UP — ";
    var ctaOnce = buybox.dataset.ctaOnce || "ADD TO CART — ";

    function isSubSelected() {
      var sub = buybox.querySelector('.glp-plan[data-plan="sub"]');
      return !!sub && sub.classList.contains("on");
    }

    var qtys = buybox.querySelectorAll(".glp-qty");

    // Compare-at prices are only rewritten when a quantity step exists, because
    // that's the only case where they change. Without one, the sticky bar's
    // compare-at comes from its own section setting and is not ours to
    // overwrite.
    var syncsCompare = qtys.length > 0;

    function render() {
      var sub = isSubSelected();
      if (subPriceEl) subPriceEl.textContent = subPrice;
      if (oncePriceEl) oncePriceEl.textContent = oncePrice;
      if (syncsCompare && compare) {
        if (subCompareEl) subCompareEl.textContent = compare;
        if (onceCompareEl) onceCompareEl.textContent = compare;
        if (stickyStrike) stickyStrike.textContent = compare;
      }
      // Labels are prefixes; the space lives here because the theme editor
      // strips trailing whitespace out of the setting.
      if (atcLabel)
        atcLabel.textContent =
          (sub ? ctaSub : ctaOnce).trim() + " " + (sub ? subPrice : oncePrice);
      if (stickyPrice) stickyPrice.textContent = sub ? subPrice : oncePrice;
      // Per-serving only exists on pages whose sticky bar opts into the
      // badge layout AND whose buy box sets servings per container.
      if (stickyPer) {
        var per = sub ? buybox.dataset.subPerServing : buybox.dataset.oncePerServing;
        if (per) stickyPer.textContent = per;
      }
    }

    qtys.forEach(function (btn) {
      btn.addEventListener("click", function () {
        qtys.forEach(function (b) {
          b.classList.remove("on");
          b.setAttribute("aria-checked", "false");
        });
        btn.classList.add("on");
        btn.setAttribute("aria-checked", "true");
        if (qtyInput && qtyInput.value !== btn.dataset.qty) qtyInput.value = btn.dataset.qty;
        subPrice = btn.dataset.subPrice || subPrice;
        oncePrice = btn.dataset.oncePrice || oncePrice;
        compare = btn.dataset.compare || compare;
        if (planMeta && btn.dataset.planMeta) planMeta.textContent = btn.dataset.planMeta;
        render();
      });
    });

    var chips = buybox.querySelectorAll(".glp-flavors .glp-chip");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) {
          c.classList.remove("on");
          c.setAttribute("aria-checked", "false");
        });
        chip.classList.add("on");
        chip.setAttribute("aria-checked", "true");
        // Guarded writes: these inputs are type=hidden, so assigning .value
        // writes the content attribute and fires the theme's form-wide
        // MutationObserver. Only write on an actual change.
        if (variantInput && variantInput.value !== chip.dataset.variantId)
          variantInput.value = chip.dataset.variantId;
        if (flavorName && flavorName.textContent !== chip.dataset.title)
          flavorName.textContent = chip.dataset.title;
        if (stickyFlavor && stickyFlavor.textContent !== chip.dataset.title)
          stickyFlavor.textContent = chip.dataset.title;
      });
    });

    var plans = buybox.querySelectorAll(".glp-plan");
    plans.forEach(function (plan) {
      var activate = function () {
        plans.forEach(function (p) {
          p.classList.remove("on");
          p.setAttribute("aria-checked", "false");
        });
        plan.classList.add("on");
        plan.setAttribute("aria-checked", "true");
        if (planInput) planInput.disabled = plan.dataset.plan !== "sub";
        render();
      };
      plan.addEventListener("click", activate);
      plan.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          activate();
        }
      });
    });

    var activeChip =
      buybox.querySelector(".glp-flavors .glp-chip.on") ||
      buybox.querySelector(".glp-flavors .glp-chip");
    if (activeChip && stickyFlavor) stickyFlavor.textContent = activeChip.dataset.title;
    render();

    applyDiscountCode(buybox);
  }

  /*
   * Auto-apply the landing page's discount code so the shopper never types it.
   *
   * UNDOCUMENTED: /cart/update.js accepts a `discount` param. It is not in
   * Shopify's AJAX Cart API reference, so it carries no compatibility promise —
   * if the discount silently stops applying, check this first. Verified live
   * 2026-07-31 against shopbeam.com:
   *   - cart-scoped, NOT a cookie: it sets no discount_code cookie, so the code
   *     rides this cart only and does not follow the shopper around the site
   *     (unlike the /discount/<code> route, which does).
   *   - it sticks on an EMPTY cart and activates as soon as a matching line is
   *     added, which is why firing once on load is safe and race-free.
   *
   * Deliberately fire-and-forget: it must never block or break add-to-cart.
   * No DOM is touched, so it cannot wake the form MutationObserver in
   * layout/theme.liquid.
   */
  function applyDiscountCode(buybox) {
    var code = (buybox.dataset.discountCode || "").trim();
    var url = buybox.dataset.cartUpdateUrl;
    if (!code || !url) return;

    // One POST per session per code — the cart remembers it after that.
    var stamp = "glpDiscount:" + code;
    try {
      if (sessionStorage.getItem(stamp)) return;
    } catch (e) {
      /* private mode / storage disabled — just apply every load */
    }

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        try {
          sessionStorage.setItem(stamp, "1");
        } catch (e) {}
      })
      .catch(function (err) {
        console.warn("[glp] could not auto-apply discount " + code + ":", err);
      });
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
